import { Box } from '@mui/material';

import { LoadingSpinner } from '@verantos-dev/shared-components';

import { AdminCardsSection } from './components/AdminCardsSection';
import { AnnotationCardsSection } from './components/AnnotationCardsSection';
import { useDashboard } from './useDashboard';

export const Dashboard = () => {
  const { theme, showLoadingSpinner, isDashboardLoading } = useDashboard();

  if (showLoadingSpinner && isDashboardLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <LoadingSpinner id="dashboardLoading" />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        pl: theme.spacing(6),
        pr: theme.spacing(6),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(6),
      }}
    >
      <AnnotationCardsSection />
      {/* Show admin section only for users with Admin role */}
      <AdminCardsSection />
    </Box>
  );
};
